import { pageShell } from "../../../styles/pageShell";
import { typeShell } from "../../../styles/typeShell";

const detailsClass =
    "box-border flex min-h-0 w-full flex-1 flex-col gap-0 overflow-hidden";

const sectionClass =
    "flex min-h-0 flex-1 basis-0 flex-col justify-start gap-4 overflow-auto";

const sectionFollowClass = `${sectionClass} mt-8`;

const titleClass = `${pageShell.sectionTitle} border-0 border-b border-solid border-border pb-2`;

const gridClass =
    "flex min-h-0 flex-1 flex-col items-center justify-center gap-section";

const infoItemClass =
    "flex min-w-0 w-full max-w-sm flex-col items-center gap-1 text-center";

const infoLabelClass = `m-0 ${typeShell.statLabel}`;

const infoValueClass = `m-0 ${typeShell.statValue}`;

export const AccountDetails = ({ user }) => {
    return (
        <div className={detailsClass}>
            <div className={sectionClass}>
                <h2 className={titleClass}>
                    <span className={pageShell.sectionIcon}>info</span>
                    基本情報
                </h2>
                <div className={gridClass}>
                    <InfoItem label="ログインID" value={user.login_id} />
                    <InfoItem label="ニックネーム" value={user.nickname || "未設定"} />
                    <InfoItem label="メールアドレス" value={user.email || "未設定"} />
                </div>
            </div>

            {user.role === "student" && user.student_profile && (
                <StudentProfile profile={user.student_profile} org={user.organization} />
            )}
            {user.role === "teacher" && user.teacher_profile && (
                <TeacherProfile profile={user.teacher_profile} org={user.organization} />
            )}
            {user.role === "admin" && <AdminProfile />}
        </div>
    );
};

const InfoItem = ({ label, value }) => (
    <div className={infoItemClass}>
        <div className={infoLabelClass}>{label}</div>
        <div className={infoValueClass}>{value}</div>
    </div>
);

const StudentProfile = ({ profile, org }) => (
    <div className={sectionFollowClass}>
        <h2 className={titleClass}>
            <span className={pageShell.sectionIcon}>school</span>
            生徒情報
        </h2>
        <div className={gridClass}>
            <InfoItem label="学校" value={org?.name || "未設定"} />
            <InfoItem label="学年" value={`${profile.grade}年`} />
            <InfoItem label="クラス" value={profile.class_name || "未設定"} />
            <InfoItem label="出席番号" value={`${profile.student_number}番`} />
        </div>
    </div>
);

const TeacherProfile = ({ profile, org }) => (
    <div className={sectionFollowClass}>
        <h2 className={titleClass}>
            <span className={pageShell.sectionIcon}>person</span>
            教師情報
        </h2>
        <div className={gridClass}>
            <InfoItem label="学校" value={org?.name || "未設定"} />
            <InfoItem label="役職" value={profile.position || "未設定"} />
        </div>
    </div>
);

const AdminProfile = () => (
    <div className={sectionFollowClass}>
        <h2 className={titleClass}>
            <span className={pageShell.sectionIcon}>admin_panel_settings</span>
            管理者情報
        </h2>
        <div className="flex min-h-0 flex-1 items-center justify-center p-0">
            <div className="flex items-center justify-center gap-3 border-none bg-transparent p-0 text-center">
                <span className="material-symbols-outlined shrink-0 text-icon-md text-success">
                    verified
                </span>
                <p className={`m-0 ${typeShell.statusMessage}`}>
                    システム設定や統計にアクセス可能です。
                </p>
            </div>
        </div>
    </div>
);
